// src/App.js
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';

import LoginPage from './pages/Login';
import RequireAuth from './hooks/RequiresAuth';
import LogoutHandler from './pages/LogoutHandler';
import AdminApp from './AdminApp';

export default function App() {
  return (
    <Router>
      <Routes>
        {/* Public route: no AdminLayout here */}
        <Route path="/login" element={<LoginPage />} />
        <Route path="/logout" element={<LogoutHandler />} />

        {/* Everything else: requires auth + uses AdminLayout */}
        <Route
          path="/*"
          element={
            <RequireAuth>
              <AdminApp />
            </RequireAuth>
          }
        />
      </Routes>
    </Router>
  );
}